export function registerSound(url) {
    let sound = document.createElement('audio')
    sound.src = `/game${url}`
    sound.setAttribute('preload', 'auto')
    sound.setAttribute('controls', 'none')
    sound.style.display = 'none'
    document.body.appendChild(sound)
    return sound
}

export function playSound(sound, options = {}) {
    try {
        if (sound) {
            sound.currentTime = 0
            sound.loop = options.loop
            sound.volume = options.volume || 1
            sound.play()
        }
    } catch (e) {
        console.error(e.message)
    }
}

